import { useState } from 'react';
import { Tab } from '@mui/material';
import InvitationManage from './InvitationManage';
import ResponseManage from './ResponseManage';
import '../../../../../styles/components/Invitation.css';
import '../../../../../styles/components/CreateEvent.css';

function Invitation() {
    const [activeTab, setActiveTabState] = useState('invites');

    return (
        <section id="create-event-tickets-section">
            <div className="event-creation-stepper">
                <Tab
                    label="Invites"
                    variant={activeTab === 'invites' ? 'main' : 'inactive'}
                    onClick={() => setActiveTabState('invites')}
                />
                <Tab
                    label="Response"
                    variant={activeTab === 'response' ? 'main' : 'inactive'}
                    onClick={() => setActiveTabState('response')}
                />
            </div>
            <div className="event-creation-tabs-content">
                {activeTab === 'invites' && <InvitationManage />}
                {activeTab === 'response' && (
                    <ResponseManage
                        backToInviteTab={() => setActiveTabState('invites')}
                    />
                )}
            </div>
        </section>
    );
}

export default Invitation;